import { isMockMode, post, simulateDelay } from "../api";

export const createLicensedServiceSub = (data) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/CreateLicensedServiceSub`, data, {
		successMessage: "Subscription successfully created",
	});
};
